<template>
  <div
    class="html_playerInfor_bar"
    ref="html_playerInfor_bar"
    v-if="datas.objectInfo && datas.objectInfo.length === 1"
  >
    <div class="main">
      <div class="left-box" :class="themetype">
        <template v-if="themetype === 'T'">
          <TeamNameLogo
            :countryImg="datas.objectInfo[0]?.teamLogo"
            :countryName="datas.objectInfo[0]?.teamName"
          />
        </template>
        <template v-if="themetype === 'A'">
          <AbPlayerImg
            v-for="item in datas.objectInfo"
            :key="item.playerId"
            :playerImg="item.playerInfos[0].profilePicture"
            :playerNum="item.playerInfos[0].shirtNumber * 1"
            :playerName="`${item.playerInfos[0].playerName}  ${
              item.playerInfos[0].position
                ? '(' + item.playerInfos[0].position + ')'
                : ''
            }`"
            :countryImg="item.teamLogo"
            :countryName="item.teamName"
            :countryLogoSize="countryLogoSize"
            :cssDynamicObj="cssDynamicObj"
          ></AbPlayerImg>
        </template>
        <template v-if="themetype === 'D'">
          <DPlayerImg
            :playerInfos="datas.objectInfo[0].playerInfos"
            :countryImg="datas.objectInfo[0].teamLogo"
            :countryName="datas.objectInfo[0].teamName"
            :countryLogoSize="countryLogoSize"
            :cssDynamicObj="cssDynamicObj"
            :width="'calc(13.88vw * var(--mixtmt_mixvw))'"
          ></DPlayerImg>
        </template>
        <template v-if="themetype === 'M'">
          <PlayerNames
            :playerInfos="datas.objectInfo[0].playerInfos"
            :countryImg="datas.objectInfo[0].teamLogo"
            :countryName="datas.objectInfo[0].teamName"
            :cssDynamicObj="cssDynamicObj"
            :width="`calc(${
              datas.objectInfo.length === 1 ? '13.88vw' : '6.94vw'
            } * var(--mixtmt_mixvw))`"
          ></PlayerNames>
        </template>
      </div>
      <div
        class="right-box"
        :class="themetype"
        v-if="statisticsModels.length > 0"
      >
        <span
          class="rowItem"
          v-for="item in statisticsModels"
          :key="item.statisticalEn"
        >
          <span class="rowItem_bg"></span>
          <span
            class="rowItem_title"
            v-text="_valFormatHandler(item.name)"
          ></span>
          <span
            class="rowItem_val"
            v-if="tableData && _valFormatHandler(tableData[item.statisticalEn])"
          >
            <template
              v-if="
                tableData[item.statisticalEn].indexOf &&
                tableData[item.statisticalEn].indexOf('/') > -1
              "
            >
              <NumberScrolling
                :tarVal="tableData[item.statisticalEn].split('/')[0]"
                unit="/"
              ></NumberScrolling>
              <NumberScrolling
                :tarVal="tableData[item.statisticalEn].split('/')[1]"
                :unit="item.suffix"
              ></NumberScrolling>
            </template>
            <template v-else>
              <NumberScrolling
                :tarVal="tableData[item.statisticalEn]"
                :unit="item.suffix"
              ></NumberScrolling>
            </template>
          </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
// 球员信息 MAP || 得分方式 等
import AbPlayerImg from '../components/PlayerImg'
import DPlayerImg from '../components/DPlayerImg'
import PlayerNames from '../components/PlayerNames'
import NumberScrolling from '../components/NumberScrolling'
import TeamNameLogo from '../components/TeamNameLogo'
// import htmlDomToImage_base64_data_mixin from '@mixins/htmlDomToImage_base64_data'
export default {
  name: 'html_playerInfor_bar',
  // mixins: [htmlDomToImage_base64_data_mixin],
  components: {
    AbPlayerImg,
    DPlayerImg,
    PlayerNames,
    NumberScrolling,
    TeamNameLogo,
  },
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
    cssDynamicObj: {
      type: Object,
      default: () => ({
        mixvw: 1,
        mixvh: 1,
        realyWidth: 0,
        realyHeight: 0,
      }),
    },
  },
  data() {
    return {}
  },
  created() {
    // 模拟数据
    console.debug(this.datas)
  },
  updated() {
    console.debug(`更新： ${this.datas}`)
  },
  computed: {
    tableData() {
      return this.datas.data.dataList && this.datas.data.dataList.length > 0
        ? this.datas.data.dataList[0]
        : {}
    },
    statisticsModels() {
      return (this.datas?.statisticsModels || []).filter((item) => item)
    },
    themetype() {
      let arr = ['T', 'A', 'D', 'M'] //M(Multiple):多人代表，在双人和团体之间
      let themetype = 'T'
      if (
        this.datas.objectInfo &&
        this.datas.objectInfo[0] &&
        this.datas.objectInfo[0].playerInfos
      ) {
        // 大于2个人以上的展示多人名，不要头像
        themetype =
          arr[
            this.datas.objectInfo[0].playerInfos.length > 2
              ? 3
              : this.datas.objectInfo[0].playerInfos.length
          ]
      }
      return themetype
    },
    countryLogoSize() {
      if (
        this.datas &&
        this.datas.sportType === 'basketball' &&
        this.datas.competitionType === 'league'
      ) {
        return [
          'calc(1.666vw * var(--mixtmt_mixvw))',
          'calc(1.666vw * var(--mixtmt_mixvw))',
        ] //['1.666vw', '1.666vw']
      } else {
        return [
          'calc(2.498vw * var(--mixtmt_mixvw))',
          'calc(1.666vw * var(--mixtmt_mixvw))',
        ] //['2.498vw', '1.666vw']
      }
    },
  },
  methods: {
    _valFormatHandler(val, ceil) {
      let data
      // console.debug('_valFormatHandler:', val, typeof val, ceil)
      if (val === undefined || val === null || val === '' || val === ' ') {
        data = ''
      } else {
        if (val && ceil) {
          data = `${val}${ceil ? ceil : ''}`
        } else {
          data = val + ''
        }
      }
      // console.debug(val, data)
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.html_playerInfor_bar {
  width: 100%;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: left;
  .main {
    width: 90%;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    color: var(--mixtmt_greyColor_main);

    .left-box {
      font-size: calc(0.972vw * var(--mixtmt_mixvw));
    }
    .right-box {
      margin-left: calc(2.083vw * var(--mixtmt_mixvw));
      height: auto;
      width: calc(20.83vw * var(--mixtmt_mixvw));
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: flex-start;
      flex-direction: column;
      max-height: calc(14.8vw * var(--mixtmt_mixvw));
      overflow: auto;
      &.D {
        width: calc(100% - (2.083vw + 13.88vw) * var(--mixtmt_mixvw));
      }
      .rowItem {
        position: relative;
        width: 100%;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        line-height: calc(2.083vw * var(--mixtmt_mixvw));
        margin-bottom: calc(0.694vw * var(--mixtmt_mixvw));
        &:last-child {
          margin-bottom: 0;
        }
        .rowItem_bg {
          width: 100%;
          background-color: var(--mixtmt_greyColor7);
          height: calc(2.083vw * var(--mixtmt_mixvw));
          border-radius: calc(1.1vw * var(--mixtmt_mixvw));
        }
        .rowItem_title {
          display: block;
          position: absolute;
          left: 0;
          top: 0;
          z-index: 2;
          width: calc(7.638vw * var(--mixtmt_mixvw));
          height: 100%;
          background: linear-gradient(
            90deg,
            var(--mixtmt_theme_defaultGradient_1_1) 0%,
            var(--mixtmt_theme_defaultGradient_1_2) 98%
          );
          color: var(--mixtmt_whiteColor);
          font-size: calc(0.972vw * var(--mixtmt_mixvw));
          font-weight: bold;
          text-align: center;
          border-radius: calc(1.1vw * var(--mixtmt_mixvw));
        }
        .rowItem_val {
          display: block;
          position: absolute;
          top: 0;
          right: 0;
          z-index: 2;
          width: calc(100% - 7.638vw * var(--mixtmt_mixvw));
          padding: 0 calc(1.388vw * var(--mixtmt_mixvw));
          text-align: right;
          color: var(--mixtmt_greyColor3);
          font-size: calc(1.25vw * var(--mixtmt_mixvw));
          font-weight: bold;
        }
      }
    }
  }
  .bottom_tip {
    margin-top: calc(1.388vw * var(--mixtmt_mixvw));
    color: #999;
    font-size: calc(0.833vw * var(--mixtmt_mixvw));
  }
  .ptb4 {
    padding: calc(0.278vw * var(--mixtmt_mixvw)) 0;
  }
}
</style>
